import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-16 md:py-24 bg-white" data-id="element-67">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-69">
          <div className="bg-gradient-to-br from-[#5d6e4f] to-[#4a5940] rounded-2xl p-8 md:p-12 text-white shadow-2xl" data-id="element-70">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-71">
              <div className="flex-shrink-0" data-id="element-72">
                <div className="w-24 h-24 md:w-32 md:h-32 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm" data-id="element-73">
                  <ShieldCheckIcon className="w-12 h-12 md:w-16 md:h-16 text-[#c9a961]" data-id="element-74" />
                </div>
              </div>

              <div className="text-center md:text-left" data-id="element-75">
                <h2 className="font-serif text-3xl md:text-4xl mb-4" data-id="element-76">
                  Garantía de Satisfacción de 30 Días
                </h2>
                <p className="text-lg md:text-xl leading-relaxed" data-id="element-77">
                  Si aplicas el protocolo y no sientes menos inflamación o no
                  duermes mejor, te devuelvo tu dinero íntegro. Así de segura
                  estoy del cambio que verás.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}